"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListSearchInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * RedPanda UI - ListSearchInput
 * 列表頁搜尋框（docs/介面優化.md R18 篩選列）；搜尋由後端查全部資料（@redpanda/utils useListSearch）
 * 中文輸入法選字中（注音、拼音還沒選字）不送出：選字完成才呼叫 onChange（主流做法，看 compositionstart／end）
 */
const react_1 = require("react");
const outline_1 = require("@heroicons/react/24/outline");
const Input_1 = require("./Input");
const ListSearchInput = ({ value, onChange, placeholder, widthClass = 'md:w-80' }) => {
    // 輸入框顯示的字（含選字中的注音）；選字完成或一般輸入才同步給頁面
    const [draft, setDraft] = (0, react_1.useState)(value);
    const composing = (0, react_1.useRef)(false);
    // 頁面改了值（例：清除篩選、點側欄回到初始狀態）時跟著換；選字中不打斷
    (0, react_1.useEffect)(() => {
        if (!composing.current)
            setDraft(value);
    }, [value]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: `relative ${widthClass}`, children: [(0, jsx_runtime_1.jsx)("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none", children: (0, jsx_runtime_1.jsx)(outline_1.MagnifyingGlassIcon, { className: "h-5 w-5 text-gray-400" }) }), (0, jsx_runtime_1.jsx)(Input_1.Input, { type: "search", value: draft, onChange: (e) => {
                    setDraft(e.target.value);
                    if (!composing.current && !e.nativeEvent.isComposing)
                        onChange(e.target.value);
                }, onCompositionStart: () => { composing.current = true; }, onCompositionEnd: (e) => {
                    composing.current = false;
                    onChange(e.currentTarget.value);
                }, placeholder: placeholder, "aria-label": placeholder, className: "w-full pl-10 h-10" })] }));
};
exports.ListSearchInput = ListSearchInput;
exports.ListSearchInput.displayName = 'ListSearchInput';
